import { render, staticRenderFns } from "./Rolemanage.vue?vue&type=template&id=58e4e5fa&scoped=true&"
import script from "./Rolemanage.vue?vue&type=script&lang=js&"
export * from "./Rolemanage.vue?vue&type=script&lang=js&"
import style0 from "./Rolemanage.vue?vue&type=style&index=0&id=58e4e5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e4e5fa",
  null
  
)

export default component.exports